define([
	"dojo/_base/array",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"./_DropDownMenuPlugin",
	"./PluginFactory",
	"./util"
], function(array,lang,_,_DropDownMenuPlugin,PluginFactory,util) {

	return PluginFactory.declare([_DropDownMenuPlugin], {
		bHideWhenDisabled: true,
		propertyKey: util.shapeProperties.arrow,
		iconClass: "csiActionIcon svgIconArrowAll",
		pluginName: "arrow",
		title: "CanvasArrows",

		startup: function() {
			this.dropDown = this.createDropDownMenu([
				"svgIconArrow0",
				"svgIconArrow1",
				"svgIconArrow2",
				"svgIconArrow3",
				"svgIconArrow4",
				"svgIconArrow5",
				"svgIconArrow6",
				"svgIconArrow7",
				"svgIconArrow8",
				"svgIconArrow9"
			]);

			this.inherited(arguments);
		},

		/**
		 * Enable arrow option only for line and curve
		 * @param {Shape[]} shapes
		 * @param {Object} shapeAttrs
		 * @param {Object} textAttrs
		 * @return {boolean}
		 */
		enablePlugin: function (shapes, shapeAttrs, textAttrs) {
			return this.inherited(arguments) && this.editor.canvasApp.selection.isSelectedShapesSupportArrow();
		},

		/**
		 * Return the object in array with given index
		 * @return {Object}
		 */
		encode: function(value) {
			return util.arrowTypes[Number(value)];
		},

		/**
		 * Return the index of given object in arrowType array.
		 * @return {number}
		 */
		decode: function(value) {
			if (value) {
				var arrowIndex = 0;
				 _.each(util.arrowTypes, function(x, index) {
					if (x.headEnd === value.headEnd && x.tailEnd === value.tailEnd) {
						arrowIndex = index;
					}
				});
				return arrowIndex;
			}
			return undefined;
		}

	});
});
